export const eClientFeaturePermissions = {
  UNSET: { value: 0, name: 'Unset' },
  CUSTOM_REMEDIATION_SERVER: { value: 1, name: 'Custom Remediation Server' },
  CloseAllOpenAlertsButton: { value: 2, name: 'Close All Open Alerts Button' },
  CreateHostsScanGroupIfNotExists: { value: 3, name: 'Create Hosts Scan Group If Not Exists' },
  SendToSOC: { value: 4, name: 'Send To SOC' },

  RunSqlWebApi: { value: 5, name: 'Run SQL via Web API' },
  ADLogin: { value: 6, name: 'Active Directory Login' },

  ManualScan: { value: 7, name: 'Manual Scan' },
  AnalyticServerSettings: { value: 8, name: 'Analytic Server Settings' },
  ExcludeIPS: { value: 9, name: 'Exclude IPS' },
  ExcludeHosts: { value: 10, name: 'ExcludeHosts' },
  LogParser: { value: 12, name: 'Log Parser' },
  VPNLogParser: { value: 13, name: 'VPN Log Parser' },
  UserDataActiveDirectory: { value: 14, name: 'Import User Data Active Directory' },
  ShowDistributionType: { value: 15, name: 'AllowChangeDistributionType' },

  EnableScheduledTasksDistributionType: { value: 16, name: 'Enable Scheduled Tasks Distribution Type' },
  EnableSSHDistributionType: { value: 17, name: 'Enable SSH Distribution Type' },

  EnableRPCDistributionType: { value: 18, name: 'Enable RPC Distribution Type' },
  EnableAutoDistributionType: { value: 19, name: 'Enable Auto Distribution Type ' },
  EnableLauncherDistributionType: { value: 20, name: 'Enable Launcher Distribution Type' },
  EnableMSIDistributionType: { value: 21, name: 'Enable MSI Distribution Type' },
  ShowScanMode: { value: 22, name: 'Show Scan Mode' },

  EnableLightAgentScanMode: { value: 23, name: 'Enable Light Agent Scan Mode' },
  EnableAlwaysOnScanMode: { value: 24, name: 'Enable Always On Scan Mode' },
  EnableIntervalScanMode: { value: 25, name: 'Enable Interval Scan Mode' },
  ADHostPopulation: { value: 26, name: 'ADHostPopulation' },

  AllowChangeScanInterval: { value: 27, name: 'Allow Change Scan Interval' },
  ScanHost: { value: 28, name: 'Scan Host' },
  ChangeIP: { value: 29, name: 'Change IP' },
  GetMemoryStrings: { value: 30, name: 'Get Memory Strings' },
  DNSRemediation: { value: 31, name: 'DNS Remediation' },
  DeepScan: { value: 32, name: 'Deep Scan' },
  UnscannedGroupAlert: { value: 33, name: 'Unscanned Group Alert' },
  ScanHistory: { value: 34, name: 'Scan History' },
  ScanScheduling: { value: 35, name: 'Scan Scheduling' },
  ConnectionSettings: { value: 36, name: 'Connection Settings' },
  MasterSlaveServerSettings: { value: 37, name: 'Master Slave Server Settings' },
  EnableChangeAutoUpdate: { value: 38, name: 'Enable Change Auto Update' },
  DecoySettings: { value: 39, name: 'Decoy Settings' },
  ShowIntegrationTab: { value: 40, name: 'Show Integration Tab' },
  ShowSystemInfoTab: { value: 41, name: 'Show System Info' },
  BillingModule: { value: 42, name: 'Billing Module' },
  ShowLogFileRetention: { value: 43, name: 'Show Log File Retention' },
  ShowStartStopScanner: { value: 44, name: 'Show Start/Stop Scanner' },
  ShowRestartScans: { value: 45, name: 'Show Restart Scans' },
  EmailRecipients: { value: 46, name: 'EmailRecipients' },
  DeviceControl: { value: 47, name: 'Device Control' },
  AdvancedReports: { value: 48, name: 'Advanced Reports' },
  ShowEncryptionTokenSettings: { value: 49, name: 'Show Encryption Token Settings' },
  CustomRemediationExecutionServer: { value: 52, name: 'Custom Remediation Execution Server' },
  TimeManagement: { value: 53, name: 'Time Management' },
  ShowEPSConfigurationTab: { value: 54, name: 'Show EPS configuration tab' },
  ShowDisableMemoryStringCollection: { value: 55, name: 'Show Disable Memory String Collection' },
  ShowSSPMPage: { value: 56, name: 'Show SSPM Page' },
  ShowSSPMUsersTable: { value: 56, name: 'Show Users Table' },
  ShowExternalIntegrationsSettings: { value: 57, name: 'Show External Intergrations Settings' },
  ShowCRJavaScriptOption: { value: 58, name: 'Show CR JavaScript Option' },
  ShowDelightedPanel: { value: 59, name: 'Show Delighted Panel' },
  ShowElevioSurvey: { value: 60, name: 'Show Elevio Survey' },
  ShowPlaybooksPage: { value: 62, name: 'Show Playbooks Page' },
  LoadFullstoryTag: { value: 63, name: 'Load Fullstory Tag' },
  PlaybookAdvancedMode: { value: 64, name: 'Playbooks Advanced Mode' },
  ShowScanGroupEpsUninstallPassword: { value: 65, name: 'Show Scan Group EPS Uninstall Password' },
  EnableScanPopulation: { value: 66, name: 'Enable Scan Population' },
  UninstallEndpoints: { value: 67, name: 'Uninstall Endpoints' },
  ReinstallEndpoints: { value: 68, name: 'Reinstall Endpoints' },
  ShowAvDeleteAction: { value: 69, name: 'Show AV Delete Action' },
  EnableDattoIntegration: { value: 70, name: 'Enable Datto Integration' },
  EnableFileFiltering: { value: 71, name: 'Enable File Filtering' },
  EnableCRJavaScriptToExecute: { value: 72, name: 'Enable CR JavaScript To Execute' },
  ShowDattoIntegration: { value: 73, name: 'Show Datto Integration' },
  ShowWebFilteringSettings: { value: 75, name: 'Show Web Filtering Settings' },
  DeviceControlOnMac: { value: 77, name: 'Device Control on Mac' },
  MitreUiDisplaySettings: { value: 78, name: 'Mitre Ui Display Settings' },
  EnableIpAndDomainExclusions: { value: 81, name: 'Enable Ip And Domain Exclusions' },
  ShowStorageDeviceExceptionTab: { value: 82, name: 'Show Storage Device Exceptions Tab' },
  EnableHostRollback: { value: 84, name: 'Enable Host Rollback' },
  ShowBillingExternalIntegrationSettings: { value: 85, name: 'Show Billing External Integration Settings' },
  ShowXdrPage: { value: 548, name: 'Show XDR Page' },
  HideAuditToS3SiemConfiguration: { value: 550, name: 'Hide Audit To S3 Siem Configuration' },
  ShowClmMetrics: { value: 553, name: 'Show CLM Metrics' },
  EnableUserInvite: { value: 554, name: 'Enable user invite' },

  //Global
  GlobalManualDeployment: { value: 500, name: 'Global Manual Deployment' },
  GlobalWebProxySettings: { value: 501, name: 'Global WebProxy Settings' },
  ShowKibana: { value: 502, name: 'Show Kibana' },
  EnableTagAssignment: { value: 503, name: 'Enable Tag Assignment' },
  GlobalProfiles: { value: 504, name: 'Global Profiles' },
  GlobalSIEMSettings: { value: 505, name: 'Global SIEM Settings' },
  SIEMKibana: { value: 506, name: 'Siem Kibana' },
  MsspStats: { value: 507, name: 'Site Activity' },
  ShowLoadedModuleTab: { value: 508, name: 'Show Loaded Module Tab' },
  ShowSocketTab: { value: 509, name: 'Show Sockets Tab' },
  ShowAPIMonitorTab: { value: 510, name: 'Show API Monitor Tab' },
  ShowExecuteScriptTab: { value: 511, name: 'Show Execute Script Tab' },
  ShowHistoryTab: { value: 512, name: 'Show History Tab' },
  ShowMitreAlerts: { value: 513, name: 'Show Mitre Alerts' },
  ShowMitreFilters: { value: 514, name: 'Show Mitre Filters' },
  EnableCreateManualCynetId: { value: 517, name: 'Manual Cynet id' },
  EnableEnforceMFA: { value: 519, name: 'Enforce MFA' },
  HideRestartScansForSaas: { value: 520, name: 'Hide Restart Scans Action Item For Saas' },
  EnablePlaybookCrNode: { value: 521, name: 'Show/hide custom remediation playbook node on ui' },
  ForensicsClick: { value: 523, name: 'Forensics from Clickhouse via GQL' },
  ShowSitesInternalInfo: { value: 524, name: 'Show Sites Internal Info' },
  ShowIncidentFindings: { value: 525, name: 'Show findings tab in incident view' },
  SendAutonomousInvestigationNotification: { value: 526, name: 'Send Autonomous Investigation Notification' },
  EnhancementGroupSettings: { value: 527, name: 'Enhancement Group Settings' },
  ShowExpendableSideBar: { value: 528, name: 'Show Expendable SideBar' },
  APICRScreen: { value: 529, name: 'Api CR Screen' },
  LoadGATag: { value: 531, name: 'Load Google Analytics' },
  EnableTrayIcon: { value: 533, name: 'Enable Tray Icon on Endpoint' },
  ShowExclusionInheritance: { value: 534, name: 'Show exclusion - Inheritance and command line' },
  ShowMitreTacticAndTechnique: { value: 535, name: 'Show mitre tactic and technique instead of alert name' },
  ExecutiveReports: { value: 537, name: 'Enable executiveReports from client frontend' },
  ManageProfilesViaMsspManager: { value: 538, name: 'Allow to manage profiles via mssp manager' },
  EnableLicenseEnforcement: { value: 541, name: 'Enable License Enforcement' },
  EnableWebApiCallForPlaybook: { value: 542, name: 'Enable web api call for Playbook' },
  ShowJsonParseNode: { value: 543, name: 'Show playbook json parse node' },
  ShowScripCRVariables: { value: 544, name: 'Show variables after Script Custom Remediation node in playbook' },
  ShowCisoKit: { value: 545, name: 'Show ciso kit option' },
  LoadPendoTag: { value: 546, name: 'Load Pendo' },
  AvScanProfiles: { value: 80, name: 'AV scan profiles' },
  ShowEndpointPage: { value: 547, name: 'Show Endpoint Page' },
  HideScannerPage: { value: 549, name: 'Hide Scanner Page' },
  AvScanOnDemand: { value: 79, name: 'AV scan - on demand' },
  EnableRunbooks: { value: 551, name: 'Show playbook runbook node and all related tabs/info' },
  ShowPlaybookResultNode: { value: 552, name: 'Show playbook result node' },
  EnableLicenseClmAndSspm: { value: 556, name: 'Show CLM and SSPM license dropdown on new site and edit site' },
  EnableApiUsers: { value: 559, name: 'Enable Api Users Page' },
  EnablePlaybooksGridView: { value: 555, name: 'Enable playbooks grid view' },
  NewOverviewPage: { value: 560, name: 'New Overview Page' },
  ShowEmailProtectionPage: { value: 562, name: 'Show email protection page' },
  ShowEmailSettingsQuarantineAction: { value: 567, name: 'Show email protection quarantine action' },
  ShowEmailProtectionPreviewAction: { value: 576, name: 'Show email protection preview action' },
  ShowNewGlobalCustomRemediationPage: { value: 561, name: 'Show new global custom remediation page' },
  ShowESPMPage: { value: 563, name: 'Show ESPM Page' },
  EnableScheduledReports: { value: 564, name: 'Show Scheduled Reports Page' },
  ShowSIEMSettingsConfigurationsInNodeBackend: {
    value: 565,
    name: 'Show SIEM Settings Configurations in node backend'
  },
  ShowDataGridTableForCR: { value: 557, name: 'Show  datagrid table for CR' },
  LoadGoogleTagManager: { value: 566, name: 'Load Google Tag Manager' },
  ShowMapsPages: { value: 568, name: 'Show Maps Pages' },
  EnableShowSitePackagesField: { value: 575, name: 'Show Site Packages Field' },
  EnableSSOLogin: { value: 569, name: 'Enable SSO Login' },
  ShowEndpointsVulnerabilitesPage: { value: 570, name: 'Show Endpoints Vulnerabilites page' },
  ShowAIOEndpointsAdditionalData: { value: 571, name: 'Show AIO endpoints additional data' },
  MitreHideOverviewAndReportsPages: { value: 572, name: 'Mitre: Hide Overview and Reports pages' },
  MitreHideAlertsSummary: { value: 574, name: 'Mitre Hide Alerts Summary' },
  BypassAIOLicenseCheck: { value: 577, name: 'Bypass AIO License Check' },
  EnableEndpointsReinstallAction: { value: 578, name: 'Enable Endpoints Reinstall Action' },
  HideScannerActions: { value: 579, name: 'Hide Scanner Actions' },
  DisableStaticAnalysis: { value: 580, name: 'Disable Static Analysis' },
  EnableWindowsEventsExternalSiem: { value: 581, name: 'Enable Windows Events External SIEM' },
  ShowAlertsTaggingCapability: { value: 582, name: 'Show Alerts Tagging Capability' },
  EnableDateTimeSettings: { value: 585, name: 'Enable Date Time Settings' },
  EnableCustomEpsCertificates: { value: 586, name: 'Enable Custom EPS Sertificates Management' },
  ShowSyslogTCPTraceLog: { value: 587, name: 'Show Syslog TCP Tracelog Connection Type' },
  ShowEspmFixUndoContentAndActions: { value: 588, name: 'Show ESPM Fix Undo content & actions' },
  EnableOperationalNotifications: { value: 590, name: 'Enable Operational Notifications' },
  EnableDeceptionAdUsers: { value: 591, name: 'Enable Deception Active Directory Users' },
  HideFileMonitoringInterval: { value: 592, name: 'Hide File Monitoring Interval' },
  EnableEmailDigest: { value: 593, name: 'Enable Email Digest' },
  EndpointsExtendedHealthMonitoring: { value: 594, name: 'Show extended details on Endpoints management page' },
  EnableAVScanAutoRemediation: { value: 595, name: 'Enable AV Scan Auto Remediation' },
  OnPremiseADUserDisableOrEnable: { value: 596, name: 'Enable On-Premise Active Directory User Disable/Enable' },
  LocalADEndpointsDiscovery: { value: 597, name: 'Enable Local AD Endpoints Discovery' },
  EnableNonPersistentEpsUninstall: { value: 598, name: 'Enable Non-Persistent EPS Uninstall' },
  WebContentFiltering: { value: 599, name: 'Enable Web Content Filtering' },
  PauseEPS: { value: 600, name: 'Allow to set host protection on pause' },
  ShowWebFilteringSettingsForMac: { value: 601, name: 'Web Content Filtering for Mac' },
  ShowMacOsGroupEpsUninstallPassword: { value: 602, name: 'Show MacOS Group EPS Uninstall Password' }
};
